import { useState, type ReactNode } from "react";
import { Fingerprint, ArrowUpRight, Check } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageProvider";

const AVATAR_PREVIEWS = ["green", "blue", "female", "braids"] as const;

// Marketing previews from Rafael's supplied examples, separate from the app's
// avatar catalog and 3D renderer. The legacy gallery still mounts on request.
export function LandingExperience({ gallery }: { gallery: ReactNode }) {
  const { t, tf } = useLanguage();
  const [showGallery, setShowGallery] = useState(false);
  const [avatar, setAvatar] = useState<(typeof AVATAR_PREVIEWS)[number]>("green");
  return (
    <div className="landing-product-preview">
      <div className="landing-preview-selector" role="group" aria-label={t("landing.v4.preview.label")}>
        <button type="button" aria-pressed={!showGallery} aria-controls="landing-product-panel" onClick={() => setShowGallery(false)}>{t("landing.v4.preview.mirror")}</button>
        <button type="button" aria-pressed={showGallery} aria-controls="landing-product-panel" onClick={() => setShowGallery(true)}>{t("landing.v4.preview.modules")}<ArrowUpRight size={14} aria-hidden="true" /></button>
      </div>
      <div id="landing-product-panel">
        {showGallery ? <div className="landing-gallery">{gallery}</div> : (
          <figure className="landing-mirror-preview">
            <div className="landing-mirror-stage">
              <div className="landing-mirror-label"><span>VYV / MIRROR</span><Fingerprint size={21} aria-hidden="true" /></div>
              <img id="landing-avatar-image" src={`/landing/avatars/${avatar}-square.webp`} width={800} height={800} loading="lazy" decoding="async" alt={t(`landing.v5.avatars.${avatar}`)} />
            </div>
            <figcaption>
              <span className="landing-eyebrow">{t("landing.v4.preview.caption")}</span>
              <p>{t("landing.v4.preview.message")}</p>
              <span className="landing-avatar-hint" id="landing-avatar-options-label">{t("landing.v5.avatars.label")}</span>
              <div className="landing-avatar-options" role="group" aria-labelledby="landing-avatar-options-label">
                {AVATAR_PREVIEWS.map((option) => (
                  <button key={option} type="button" aria-label={tf("landing.v5.avatars.select", { avatar: t(`landing.v5.avatars.${option}`) })} aria-pressed={avatar === option} aria-controls="landing-avatar-image" onClick={() => setAvatar(option)}>
                    <img src={`/landing/avatars/${option}-thumb.webp`} width={160} height={160} alt="" loading="lazy" decoding="async" />
                    {avatar === option && <span className="landing-avatar-selected"><Check size={12} strokeWidth={3} aria-hidden="true" /></span>}
                  </button>
                ))}
              </div>
            </figcaption>
          </figure>
        )}
      </div>
    </div>
  );
}
